module.exports = __webpack_public_path__ + "static/img/rules-bg.615ef5d1.png";